import { useMsal } from "@azure/msal-react";
import SSOService from "../services/SSOService";
import { APIStatus } from "../constants/constant";
import CanNotEnter from "../assets/images/CanNotEnter.svg"
import "../styles/StudentPage.css";

const ErrorPage = ({ message }) => {
    const { instance } = useMsal();
    const { postLogout } = SSOService();

    const handleLogout = async () => {
        try {
            const response = await postLogout();
            if (response.status === APIStatus.success) {
                console.log("Logout thành công, thực hiện logoutRedirect.");
                instance.logoutPopup({
                    postLogoutRedirectUri: "/",
                    // mainWindowRedirectUri: "/"
                });
                localStorage.removeItem("idTeamSelected");
            } else {
                console.error("Lỗi khi logout:", response.data);
            }
        } catch (error) {
            console.error("Lỗi trong quá trình logout:", error);
        }
    };
    return (
        <div className="student_page_container">
            <img className="inform_image" src={CanNotEnter} alt="errror" />
            <p>{message}</p>
            <button onClick={() => handleLogout()}>Logout</button>
        </div>
    );
}

export default ErrorPage;